import { EuiEmptyPrompt, EuiText } from "@inscopix/ideas-eui";
import { ButtonCreateTool } from "components/ButtonCreateTool/ButtonCreateTool";

interface PromptFirstCustomToolProps {
  tenantId: number;
  tenantKey: string;
}

export const PromptFirstCustomTool = ({
  tenantId,
  tenantKey,
}: PromptFirstCustomToolProps) => {
  return (
    <EuiEmptyPrompt
      title={<h2>Create your first custom tool!</h2>}
      style={{ maxWidth: "100%" }}
      titleSize="xs"
      iconType="wrench"
      body={
        <p>
          <EuiText>
            All data in IDEAS is analyzed using tools. Start your first tool to
            begin analyzing your data using custom code.
          </EuiText>
        </p>
      }
      actions={[
        <ButtonCreateTool key="create-tool" tenantKey={tenantKey} filled />,
      ]}
    />
  );
};
